import { Route } from '@angular/router';
import { CommercialEditComponent } from 'src/app/pages/campaigns/bookings/commercial-edit/commercial-edit.component';
import { CommercialsListComponent } from 'src/app/pages/campaigns/bookings/commercials-list/commercials-list.component';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { requirements } from './requirements';
import { RoutingID } from '../../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const commercials: Route = {
  path: 'commercials/:campaignID',
  title: 'nav.campaigns.commercials',
  data: {
    breadcrumb: 'nav.campaigns.commercials',
    icon: SbIcons.commercial,
    id: RoutingID.commercials,
  },
  children: [
    {
      path: '',
      component: CommercialsListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'commercial-edit/:commercialID',
      title: 'nav.campaigns.commercials.edit',
      data: {
        breadcrumb: 'nav.campaigns.commercials.edit',
        icon: SbIcons.edit,
        id: RoutingID.commercialsEdit,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: CommercialEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'commercial-create',
      title: 'nav.campaigns.commercials.create',
      data: {
        breadcrumb: 'nav.campaigns.commercials.create',
        icon: SbIcons.plus,
        id: RoutingID.commercialsCreate,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: CommercialEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    requirements,
  ],
};
